import { createContext } from 'react';

const SelectedItemsContext = createContext(null);

export default SelectedItemsContext;
